/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ErrorResponse,
  PaginatedTrackVersionList,
  PatchedTrackVersionRequest,
  TrackVersion,
  TrackVersionCreateRequest,
  TrackVersionListParams,
  TrackVersionMoveRequest,
  TrackVersionRequest,
  TrackVersionSplitRequest,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자 트랙의 모든 버전을 조회합니다. 트랙 ID로 필터링 가능합니다.
 * @summary 버전 목록 조회
 */
export const trackVersionList = (
  params?: TrackVersionListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedTrackVersionList>(
    { url: `/api/track-versions/`, method: "GET", params, signal },
    options,
  );
};

export const getTrackVersionListQueryKey = (
  params?: TrackVersionListParams,
) => {
  return [`/api/track-versions/`, ...(params ? [params] : [])] as const;
};

export const getTrackVersionListQueryOptions = <
  TData = Awaited<ReturnType<typeof trackVersionList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackVersionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTrackVersionListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackVersionList>>
  > = ({ signal }) => trackVersionList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof trackVersionList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrackVersionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionList>>
>;
export type TrackVersionListQueryError = ErrorType<ErrorResponse>;

export function useTrackVersionList<
  TData = Awaited<ReturnType<typeof trackVersionList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | TrackVersionListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackVersionList>>,
          TError,
          Awaited<ReturnType<typeof trackVersionList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackVersionList<
  TData = Awaited<ReturnType<typeof trackVersionList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackVersionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackVersionList>>,
          TError,
          Awaited<ReturnType<typeof trackVersionList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackVersionList<
  TData = Awaited<ReturnType<typeof trackVersionList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackVersionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 버전 목록 조회
 */

export function useTrackVersionList<
  TData = Awaited<ReturnType<typeof trackVersionList>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: TrackVersionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrackVersionListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 트랙에 새 버전을 생성합니다.
 * @summary 버전 생성
 */
export const trackVersionCreate = (
  trackVersionCreateRequest: BodyType<TrackVersionCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackVersion>(
    {
      url: `/api/track-versions/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackVersionCreateRequest,
      signal,
    },
    options,
  );
};

export const getTrackVersionCreateMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionCreate>>,
    TError,
    { data: BodyType<TrackVersionCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionCreate>>,
  TError,
  { data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionCreate>>,
    { data: BodyType<TrackVersionCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return trackVersionCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionCreate>>
>;
export type TrackVersionCreateMutationBody =
  BodyType<TrackVersionCreateRequest>;
export type TrackVersionCreateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전 생성
 */
export const useTrackVersionCreate = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionCreate>>,
      TError,
      { data: BodyType<TrackVersionCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionCreate>>,
  TError,
  { data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 특정 버전의 상세 정보를 조회합니다.
 * @summary 버전 상세 조회
 */
export const trackVersionRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackVersion>(
    { url: `/api/track-versions/${id}/`, method: "GET", signal },
    options,
  );
};

export const getTrackVersionRetrieveQueryKey = (id?: string) => {
  return [`/api/track-versions/${id}/`] as const;
};

export const getTrackVersionRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof trackVersionRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTrackVersionRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackVersionRetrieve>>
  > = ({ signal }) => trackVersionRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackVersionRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrackVersionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionRetrieve>>
>;
export type TrackVersionRetrieveQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useTrackVersionRetrieve<
  TData = Awaited<ReturnType<typeof trackVersionRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackVersionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof trackVersionRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackVersionRetrieve<
  TData = Awaited<ReturnType<typeof trackVersionRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackVersionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof trackVersionRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackVersionRetrieve<
  TData = Awaited<ReturnType<typeof trackVersionRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 버전 상세 조회
 */

export function useTrackVersionRetrieve<
  TData = Awaited<ReturnType<typeof trackVersionRetrieve>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrackVersionRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 버전의 모든 필드를 수정합니다.
 * @summary 버전 전체 수정
 */
export const trackVersionUpdate = (
  id: string,
  trackVersionRequest: BodyType<TrackVersionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<TrackVersion>(
    {
      url: `/api/track-versions/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackVersionRequest,
    },
    options,
  );
};

export const getTrackVersionUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionUpdate>>,
    TError,
    { id: string; data: BodyType<TrackVersionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionUpdate>>,
  TError,
  { id: string; data: BodyType<TrackVersionRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionUpdate>>,
    { id: string; data: BodyType<TrackVersionRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackVersionUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionUpdate>>
>;
export type TrackVersionUpdateMutationBody = BodyType<TrackVersionRequest>;
export type TrackVersionUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전 전체 수정
 */
export const useTrackVersionUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionUpdate>>,
      TError,
      { id: string; data: BodyType<TrackVersionRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionUpdate>>,
  TError,
  { id: string; data: BodyType<TrackVersionRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 버전의 일부 필드만 수정합니다.
 * @summary 버전 부분 수정
 */
export const trackVersionPartialUpdate = (
  id: string,
  patchedTrackVersionRequest: BodyType<PatchedTrackVersionRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<TrackVersion>(
    {
      url: `/api/track-versions/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedTrackVersionRequest,
    },
    options,
  );
};

export const getTrackVersionPartialUpdateMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedTrackVersionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedTrackVersionRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionPartialUpdate>>,
    { id: string; data: BodyType<PatchedTrackVersionRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackVersionPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionPartialUpdate>>
>;
export type TrackVersionPartialUpdateMutationBody =
  BodyType<PatchedTrackVersionRequest>;
export type TrackVersionPartialUpdateMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전 부분 수정
 */
export const useTrackVersionPartialUpdate = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedTrackVersionRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedTrackVersionRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 버전을 삭제합니다.
 * @summary 버전 삭제
 */
export const trackVersionDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/track-versions/${id}/`, method: "DELETE" },
    options,
  );
};

export const getTrackVersionDestroyMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["trackVersionDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return trackVersionDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionDestroy>>
>;

export type TrackVersionDestroyMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전 삭제
 */
export const useTrackVersionDestroy = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getTrackVersionDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 이 버전을 확장하여 더 긴 오디오를 생성합니다 (최대 8분). Suno API Extend 엔드포인트를 사용하여 현재 오디오에서 계속 생성합니다.
 * @summary 버전 확장
 */
export const trackVersionExtend = (
  id: string,
  trackVersionCreateRequest: BodyType<TrackVersionCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/track-versions/${id}/extend/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackVersionCreateRequest,
      signal,
    },
    options,
  );
};

export const getTrackVersionExtendMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionExtend>>,
    TError,
    { id: string; data: BodyType<TrackVersionCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionExtend>>,
  TError,
  { id: string; data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionExtend"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionExtend>>,
    { id: string; data: BodyType<TrackVersionCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackVersionExtend(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionExtendMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionExtend>>
>;
export type TrackVersionExtendMutationBody =
  BodyType<TrackVersionCreateRequest>;
export type TrackVersionExtendMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전 확장
 */
export const useTrackVersionExtend = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionExtend>>,
      TError,
      { id: string; data: BodyType<TrackVersionCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionExtend>>,
  TError,
  { id: string; data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionExtendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Suno API에서 가져온 단어 단위 가사 타임스탬프를 반환합니다. Shorts 자막/카라오케 효과 + 프론트 시간대별 가사 표시에 사용합니다. 응답 본문이 클 수 있어(수십~수백 KB) 별도 엔드포인트로 분리되어 있습니다.
 * @summary 가사 타임스탬프 정렬 데이터 조회
 */
export const trackVersionLyricsAlignment = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/track-versions/${id}/lyrics-alignment/`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getTrackVersionLyricsAlignmentQueryKey = (id?: string) => {
  return [`/api/track-versions/${id}/lyrics-alignment/`] as const;
};

export const getTrackVersionLyricsAlignmentQueryOptions = <
  TData = Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTrackVersionLyricsAlignmentQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackVersionLyricsAlignment>>
  > = ({ signal }) => trackVersionLyricsAlignment(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TrackVersionLyricsAlignmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionLyricsAlignment>>
>;
export type TrackVersionLyricsAlignmentQueryError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

export function useTrackVersionLyricsAlignment<
  TData = Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
          TError,
          Awaited<ReturnType<typeof trackVersionLyricsAlignment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackVersionLyricsAlignment<
  TData = Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
          TError,
          Awaited<ReturnType<typeof trackVersionLyricsAlignment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useTrackVersionLyricsAlignment<
  TData = Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 가사 타임스탬프 정렬 데이터 조회
 */

export function useTrackVersionLyricsAlignment<
  TData = Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackVersionLyricsAlignment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getTrackVersionLyricsAlignmentQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 같은 플레이리스트 내의 다른 트랙으로 버전을 이동합니다. 트랙의 유일한 버전은 이동할 수 없습니다.
 * @summary 버전을 다른 트랙으로 이동
 */
export const trackVersionMove = (
  id: string,
  trackVersionMoveRequest: BodyType<TrackVersionMoveRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackVersion>(
    {
      url: `/api/track-versions/${id}/move/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackVersionMoveRequest,
      signal,
    },
    options,
  );
};

export const getTrackVersionMoveMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionMove>>,
    TError,
    { id: string; data: BodyType<TrackVersionMoveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionMove>>,
  TError,
  { id: string; data: BodyType<TrackVersionMoveRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionMove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionMove>>,
    { id: string; data: BodyType<TrackVersionMoveRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackVersionMove(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionMoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionMove>>
>;
export type TrackVersionMoveMutationBody = BodyType<TrackVersionMoveRequest>;
export type TrackVersionMoveMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전을 다른 트랙으로 이동
 */
export const useTrackVersionMove = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionMove>>,
      TError,
      { id: string; data: BodyType<TrackVersionMoveRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionMove>>,
  TError,
  { id: string; data: BodyType<TrackVersionMoveRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionMoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 이 버전을 트랙의 최종 선택으로 설정합니다. 선택된 버전의 오디오가 트랙의 기본 오디오가 됩니다.
 * @summary 버전 선택
 */
export const trackVersionSelect = (
  id: string,
  trackVersionCreateRequest: BodyType<TrackVersionCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackVersion>(
    {
      url: `/api/track-versions/${id}/select/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackVersionCreateRequest,
      signal,
    },
    options,
  );
};

export const getTrackVersionSelectMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionSelect>>,
    TError,
    { id: string; data: BodyType<TrackVersionCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionSelect>>,
  TError,
  { id: string; data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionSelect"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionSelect>>,
    { id: string; data: BodyType<TrackVersionCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackVersionSelect(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionSelectMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionSelect>>
>;
export type TrackVersionSelectMutationBody =
  BodyType<TrackVersionCreateRequest>;
export type TrackVersionSelectMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전 선택
 */
export const useTrackVersionSelect = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionSelect>>,
      TError,
      { id: string; data: BodyType<TrackVersionCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionSelect>>,
  TError,
  { id: string; data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionSelectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 버전을 새 트랙으로 분리합니다. 트랙의 유일한 버전은 분리할 수 없습니다.
 * @summary 버전을 새 트랙으로 분리
 */
export const trackVersionSplit = (
  id: string,
  trackVersionSplitRequest: BodyType<TrackVersionSplitRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackVersion>(
    {
      url: `/api/track-versions/${id}/split/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackVersionSplitRequest,
      signal,
    },
    options,
  );
};

export const getTrackVersionSplitMutationOptions = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionSplit>>,
    TError,
    { id: string; data: BodyType<TrackVersionSplitRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionSplit>>,
  TError,
  { id: string; data: BodyType<TrackVersionSplitRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionSplit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionSplit>>,
    { id: string; data: BodyType<TrackVersionSplitRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackVersionSplit(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionSplitMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionSplit>>
>;
export type TrackVersionSplitMutationBody = BodyType<TrackVersionSplitRequest>;
export type TrackVersionSplitMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 버전을 새 트랙으로 분리
 */
export const useTrackVersionSplit = <
  TError = ErrorType<
    ErrorResponse | ErrorResponse | ErrorResponse | ErrorResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionSplit>>,
      TError,
      { id: string; data: BodyType<TrackVersionSplitRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionSplit>>,
  TError,
  { id: string; data: BodyType<TrackVersionSplitRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionSplitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 이 버전의 플레이리스트 포함 상태를 토글합니다. 포함되지 않은 버전은 최종 플레이리스트 컴파일에서 제외됩니다.
 * @summary 포함 상태 토글
 */
export const trackVersionToggleIncluded = (
  id: string,
  trackVersionCreateRequest: BodyType<TrackVersionCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TrackVersion>(
    {
      url: `/api/track-versions/${id}/toggle-included/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: trackVersionCreateRequest,
      signal,
    },
    options,
  );
};

export const getTrackVersionToggleIncludedMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackVersionToggleIncluded>>,
    TError,
    { id: string; data: BodyType<TrackVersionCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackVersionToggleIncluded>>,
  TError,
  { id: string; data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationKey = ["trackVersionToggleIncluded"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackVersionToggleIncluded>>,
    { id: string; data: BodyType<TrackVersionCreateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return trackVersionToggleIncluded(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackVersionToggleIncludedMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackVersionToggleIncluded>>
>;
export type TrackVersionToggleIncludedMutationBody =
  BodyType<TrackVersionCreateRequest>;
export type TrackVersionToggleIncludedMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 포함 상태 토글
 */
export const useTrackVersionToggleIncluded = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackVersionToggleIncluded>>,
      TError,
      { id: string; data: BodyType<TrackVersionCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackVersionToggleIncluded>>,
  TError,
  { id: string; data: BodyType<TrackVersionCreateRequest> },
  TContext
> => {
  const mutationOptions = getTrackVersionToggleIncludedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
